import { Box, Card, CardBody, Heading, Icon, Text } from "@chakra-ui/react";
import Aos from "aos"
import "aos/dist/aos.css"
import React,{useEffect} from "react";
import {
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiReact,
  SiChakraui,
  SiRedux,
  SiExpress,
  SiMongodb,
  SiNpm,
  SiCypress,
} from "react-icons/si";
import { FaNode } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { DiTechcrunch } from "react-icons/di";
import { ImDatabase } from "react-icons/im";
import { SimpleGrid } from "@chakra-ui/react";

const Skills = () => {
  useEffect(()=>{
    Aos.init({ duration: 2000})
  },[])
  return (
    <Box bg="RGBA(0, 0, 0, 0.04)" pb={["70px"]} pt={["70px"]} id="Skills" align="center" mb="70px">
      <Heading
        fontSize={["35px", "35px", "55px"]}
        p="30px"
        display="flex"
        justifyContent="center"
        fontFamily="Serif"
        data-aos="fade-down"
      >
        Skills
      </Heading>
      <Box mt="10" >
        <SimpleGrid mr={[10,0,0,0]} align="center" w="65%"  columns={[2, 3, 4]} spacing="80px">
          <Card  data-aos="fade-right" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",
              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody  h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]} >
              <Box >
                <Icon boxSize={["30px", "50px", "60px"]} as={ImDatabase} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  DSA
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-right"
          h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
              transitionDuration: "300ms",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiHtml5} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  {" "}
                  HTML
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-right" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiCss3} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  CSS
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-right" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiJavascript} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  JavaScript
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="flip-left" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiReact} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  React
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card  data-aos="flip-left" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiChakraui} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  Chakra UI
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="flip-left" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiRedux} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  Redux
                </Text>
              </Box>
            </CardBody>
          </Card>
          
          <Card data-aos="fade-down" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiExpress} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  Express JS
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-down" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiMongodb} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  Mongo DB
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-down" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",

              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={SiNpm} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  NPM
                </Text>
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-down" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",
              boxShadow:
                "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px;",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={BsGithub} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  Git
                </Text>{" "}
              </Box>
            </CardBody>
          </Card>
          <Card data-aos="fade-up" h={["120px","120px","120px","150px"]} w={["120px","120px","120px","150px"]}
            _hover={{
              transitionDuration: "300ms",
              boxShadow: "dark-lg",
            }}
            borderRadius="15%"
            boxShadow="2xl"
          >
            <CardBody>
              <Box>
                <Icon boxSize={["40px", "50px", "60px"]} as={FaNode} />
                <Text
                  fontWeight="semibold"
                  fontSize={["8px", "10.455px", "15px"]}
                >
                  Node JS
                </Text>
              </Box>
            </CardBody>
          </Card>
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default Skills;
